module.exports = __webpack_public_path__ + "static/media/groups.b17bbe03.svg";